var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './index.scss';
import classnames from 'classnames';
import React, { forwardRef } from 'react';
const Button = forwardRef((props, ref) => {
    const { primary, secondary, outline, children, className, small, large, loading, disabled } = props, rest = __rest(props, ["primary", "secondary", "outline", "children", "className", "small", "large", "loading", "disabled"]);
    const btnClass = classnames('button', className, {
        primary: primary,
        secondary: secondary,
        loading: loading,
        outline: outline,
        small: small && !large,
        large: large && !small,
    });
    return (React.createElement("button", Object.assign({ className: btnClass, ref: ref }, rest, { disabled: loading || disabled }),
        React.createElement("span", { key: +(!!loading) }, loading ? React.createElement("i", { className: "fa fa-spinner fa-spin" }) : children)));
});
export default Button;
